import { inject } from 'vue'
export const SoftwareTokenMfa = (to: any, from: any) => {
  const isTotpInitialized = inject('isTotpInitialized') as () => boolean
  if (!isTotpInitialized()) {
    return { name: 'LoginView' }
  }
}
